import { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { motion } from 'framer-motion';
import './Dialog.css';

function Dialog({ onClose }) {
    const [posts, setPosts] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    const partNames = [
        { post: 1, name: "Légendes made in the 70ies" }, 
        { post: 2, name: "Sur la piste du disco funk" },
        { post: 3, name: "Retour vers le futur" },
        { post: 4, name: "Photo Doc Machine" },
        { post: 5, name: "Urgence à Malibu" },
        { post: 6, name: "Rembobine les 90ies" },
        { post: 7, name: "Talent Academy" },
        { post: 8, name: "Mission Cartoons" },
        { post: 9, name: "Chronoquizz 2010" },
        { post: 10, name: "Selfie stick" },
        { post: 11, name: "Check 2020" },
        { post: 12, name: "Mask and play" },
        { post: 13, name: "Retour dans le son du futur" }
    ];  

    const fetchPosts = async () => {
        try {
            setIsLoading(true);
            const response = await fetch('https://roulette.mediamatique.dev/Backend/Wheel.php?action=getAllHistory');
            const data = await response.json();

            if (data.success) {
                const groupedPosts = data.posts.reduce((acc, post) => {
                    if (post.status === '1') {
                        if (!acc[post.postId]) {
                            acc[post.postId] = {
                                postId: post.postId,
                                status: '1',
                                groups: [],
                            };
                        }
                        acc[post.postId].groups.push(post.groupName);
                    }
                    return acc;
                }, {});

                for (let i = 1; i <= 13; i++) {
                    if (!groupedPosts[i]) {
                        groupedPosts[i] = {
                            postId: i,
                            status: '0',
                            groups: [],
                        };
                    }
                }

                const sortedPosts = Object.values(groupedPosts).sort((a, b) => a.postId - b.postId);
                setPosts(sortedPosts);
            } else {
                throw new Error(data.message || 'Erreur inconnue lors de la récupération des données.');
            }
        } catch (error) {
            console.error('Erreur lors de la récupération des postes :', error);
            setError(error.message || 'Une erreur est survenue.');
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchPosts();
    }, []);

    const handleClickOutside = (e) => {
        if (e.target.classList.contains('dialog')) {
            onClose();
        }
    };

    return (
        <motion.div
            className="dialog"
            onClick={handleClickOutside}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
        >
            <motion.div
                className="wrapper"
                initial={{ y: '-100vh' }}
                animate={{ y: 0 }}
                exit={{ y: '-100vh' }}
                transition={{ type: 'spring', stiffness: 70, damping: 15 }}
            >
                <h1>Plan des postes</h1>
                <button className="btn-close" onClick={onClose}>
                    <FontAwesomeIcon icon={faXmark} />
                </button>
                <div className="container-box">
                    {isLoading && <p>Chargement des postes...</p>}
                    {error && <p className="error">{error}</p>}
                    {!isLoading && !error && posts.map((post) => (
                        <div className="box" key={post.postId}>
                            <h2>{partNames.find(part => part.post === post.postId)?.name || `Poste ${post.postId}`}</h2>
                            <div className="box-info">
                                <h3 className={post.status === '1' ? 'occupied' : 'free'}>
                                    {post.status === '1' ? 'Occupé' : 'Libre'}
                                </h3>
                                {post.groups[0] && <h4>{post.groups[0]}</h4>}
                                {post.groups[1] && <h5>{post.groups[1]}</h5>}
                            </div>
                        </div>
                    ))}
                    {!isLoading && !error && posts.length === 0 && (
                        <p>Aucun poste disponible.</p>
                    )}
                </div>
            </motion.div>
        </motion.div>
    );
}

export default Dialog;
